import { helpers } from '@vuelidate/validators';

/**
 * Validates expiration dates.
 */
export default helpers.withParams(
  { type: 'expiration', message: 'Expiration Date does not match the required format.' },
  value => /^(?:0[1-9]|1[0-2])\/?([0-9]{2}|[0-9]{4})$/.test(value),
);
